import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.jsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../fonts/graphik-regular/graphik-regular.woff\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/graphik-bold/graphik-bold.woff\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../fonts/graphik-semibold/graphik-semibold.woff\",\"weight\":\"600\",\"style\":\"normal\"}]}],\"variableName\":\"graphikFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/swiper.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/modules/a11y.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/modules/navigation.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/modules/pagination.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/atoms/Card/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/atoms/Paragraph/index.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/main.scss");
